'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  RECEIVED_COMMAND_MESSAGE: null,

  // block visitor
  RECEIVED_VISITOR_BLOCKED: null,
  BLOCK_VISITOR: null,
  BLOCK_VISITOR_REQUEST_SUCCEEDED: null,
  BLOCK_VISITOR_REQUEST_FAILED: null,

  DELETE_BLOCKED_VISITOR: null,
  DELETE_BLOCKED_VISITOR_SUCCEEDED: null,
  DELETE_BLOCKED_VISITOR_FAILED: null,

  FETCH_BLOCKED_VISITORS_FAILED: null,
  FETCH_BLOCKED_VISITORS_SUCCEEDED: null,
  FETCH_BLOCKED_VISITORS: null,

  CLICK_NOTIFICATION_PERMISSION_HELP_LINK: null,
  SELECT_PERMISSION_VALUE: null,
  CLICK_BANNER_ACTION: null,

  LEFT_ONBOARDING: null,

  APP_IN_FOREGROUND: null,
  APP_IN_BACKGROUND: null,

  CLICK_PROFILE_TIP: null,
  DISMISS_PROFILE_TIP: null,

  SELECT_EMBED_CODE_OPTION: null,

  APP_STARTED: null,
  RESET_STATUS: null,
  TOGGLE_OPEN: null,

  SET_REP_STATUS_SUCCEEDED: null,
  SET_REP_STATUS_FAILED: null,

  // Fetch Contact
  GET_CONTACT_SUCCEEDED: null,
  GET_CONTACT_FAILED: null,
  GET_CONTACT: null,
  CLEAR_CONTACT: null,

  // SHARED_UI
  SET_RECIPIENT_TIMEOUT: null,
  CLEAR_RECIPIENT_TIMEOUT: null,

  // AdminUI
  SET_CHAT_FILTER: null,
  CLOSE_CONVERSATION: null,
  CLOSE_CONVERSATION_SUCCEEDED: null,
  CLOSE_CONVERSATION_FAILED: null,

  // Chat Typing
  CHAT_INPUT_CHANGED: null,
  SEND_TYPING_STATE: null,
  SET_SHOW_TYPING_INDICATOR: null,
  UPDATE_TYPING_STATE: null,

  // Alerts
  CREATE_ALERT: null,
  DELETE_ALERT: null,

  // MESSAGES
  GET_MESSAGES: null,
  GET_MESSAGES_FAILED: null,
  GET_MESSAGES_SUCCEEDED: null,
  CREATE_MESSAGE: null,
  CREATE_MESSAGE_FAILED: null,
  CREATE_MESSAGE_SUCCEEDED: null,
  UPDATE_MESSAGE: null,
  UPDATE_MESSAGE_FAILED: null,
  UPDATE_MESSAGE_SUCCEEDED: null,
  DELETE_MESSAGE: null,
  DELETE_MESSAGE_FAILED: null,
  DELETE_MESSAGE_SUCCEEDED: null,

  // USER SETTINGS
  GET_USER_SETTINGS: null,
  GET_USER_SETTINGS_FAILED: null,
  GET_USER_SETTINGS_SUCCEEDED: null,
  UPDATE_USER_SETTINGS: null,
  UPDATE_USER_SETTINGS_FAILED: null,
  UPDATE_USER_SETTINGS_SUCCEEDED: null,
  REVERT_USER_SETTINGS: null,

  // PORTAL SETTINGS
  GET_PORTAL_SETTINGS: null,
  GET_PORTAL_SETTINGS_FAILED: null,
  GET_PORTAL_SETTINGS_SUCCEEDED: null,
  UPDATE_PORTAL_SETTINGS: null,
  UPDATE_PORTAL_SETTINGS_FAILED: null,
  UPDATE_PORTAL_SETTINGS_SUCCEEDED: null,
  REVERT_PORTAL_SETTINGS: null,
  SET_PORTAL_SETTING: null,

  GET_USERS: null,
  GET_USERS_FAILED: null,
  GET_USERS_SUCCEEDED: null,

  GET_TEAMS: null,
  GET_TEAMS_FAILED: null,
  GET_TEAMS_SUCCEEDED: null,

  GET_CHAT_CONFIG: null,
  GET_CHAT_CONFIG_FAILED: null,
  GET_CHAT_CONFIG_SUCCEEDED: null,

  // CONVERSATION DATA
  GET_CONVERSATIONS: null,
  GET_CONVERSATIONS_FAILED: null,
  GET_CONVERSATIONS_SUCCEEDED: null,
  CREATED_CONTACT_FOR_CHANNEL: null,

  GET_CHAT_HISTORY: null,
  GET_CHAT_HISTORY_FAILED: null,
  GET_CHAT_HISTORY_SUCCEEDED: null,
  SET_INITIAL_MESSAGE_IN_CHANNEL: null,

  // GET VISITOR
  GET_VISITOR_FOR_CHANNEL: null,
  RECEIVED_VISITOR_FOR_CHANNEL: null,
  RECEIVED_VISITOR_FOR_CHANNEL_FAILED: null,

  // PUBNUB
  PUBNUB_CLIENT_CONNECTED: null,
  OPEN_CONVERSATION_FOR_NEW_CHANNEL: null,
  RECEIVED_INCOMING_MESSAGE: null,
  RECEIVED_PUBNUB_PRESENCE: null,
  RECEIVED_PUBNUB_STATUS: null,
  SET_CURRENT_CHANNEL: null,
  CLOSE_PUBNUB_CONVERSATION: null,
  SWITCH_PUBNUB_CHANNEL: null,
  LEAVE_CHANNELS: null,
  SUBSCRIBE_TO_OPEN_CHANNELS: null,
  LEAVE_LOBBY: null,
  JOIN_LOBBY: null,
  SUBSCRIBE_CONFIRMATION: null,
  CLEAR_UNSEEN_COUNT: null,
  INCREMENT_UNSEEN_COUNT: null,
  ADD_MESSAGE_TO_CONVERSATION: null,
  UPDATE_MESSAGE_IN_CONVERSATION: null,
  START_CONVERSATION: null,
  END_CONVERSATION: null,
  GET_SERVER_TIME_OFFSET: null,
  GET_SERVER_TIME_OFFSET_SUCCEEDED: null,
  GET_SERVER_TIME_OFFSET_FAILED: null,
  LEAVE_CHANNEL: null,

  // PUBNUB NOTIFICATIONS
  NETWORK_OFFLINE: null,
  NETWORK_ONLINE: null,

  // ONLINE MESSAGE SENDING
  PUBLISH_OUTGOING_MESSAGE: null,
  PUBLISH_OUTGOING_MESSAGE_SUCCESS: null,
  PUBLISH_OUTGOING_MESSAGE_FAILURE: null,

  // OFFLINE MESSAGE SENDING
  SEND_OFFLINE_MESSAGE: null,
  SEND_OFFLINE_MESSAGE_SUCCEEDED: null,
  SEND_OFFLINE_MESSAGE_FAILED: null,

  // OUTGOING MESSAGE QUEUE
  ENQUEUE_OUTGOING_MESSAGE: null,
  SHIFT_OUTGOING_MESSAGES: null,
  CLEAR_OUTGOING_MESSAGES: null,

  // MEETINGS
  GET_MEETINGS_LINKS: null,
  GET_MEETINGS_LINKS_FAILED: null,
  GET_MEETINGS_LINKS_SUCCEEDED: null,

  // WIDGET
  GET_WIDGET_DATA: null,
  GET_WIDGET_DATA_FAILED: null,
  GET_WIDGET_DATA_SUCCEEDED: null,
  SET_MOCK_WIDGET_DATA: null,
  CLICK_VIRAL_LINK: null,

  // EMBED CODE
  SEND_EMBED_CODE_EMAIL: null,
  SEND_EMBED_CODE_EMAIL_FAILED: null,
  SEND_EMBED_CODE_EMAIL_SUCCEEDED: null,

  // VISITOR EMAIL ADDRESS
  SEND_VISITOR_EMAIL_ADDRESS: null,
  SEND_VISITOR_EMAIL_ADDRESS_FAILED: null,
  SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED: null,

  // HUBSHOT
  GET_SCREENSHOT: null,
  GET_SCREENSHOT_FAILED: null,
  GET_SCREENSHOT_SUCCEEDED: null,

  // SMART LISTS
  GET_SMART_LISTS: null,
  GET_SMART_LISTS_FAILED: null,
  GET_SMART_LISTS_SUCCEEDED: null,

  // USER SETTINGS
  SET_USER_SETTING: null,
  UNSET_MEETINGS_LINK_DATA: null,
  TOGGLE_NOTIFICATION: null,

  // EDIT MESSAGE
  STAGE_NEW_MESSAGE: null,
  RESET_MESSAGE_STAGE: null,
  STAGE_EXISTING_MESSAGE: null,
  SET_MESSAGE_PROPERTY: null,
  SET_MESSAGE_TARGET_AUDIENCE: null,
  TOGGLE_MESSAGE_STATUS: null,
  SET_MESSAGE_ROUTING_IDS: null,

  // PAGES
  ADD_TARGET_URL: null,
  EDIT_TARGET_URL: null,
  DELETE_TARGET_URL: null,

  // GENERIC LOGGING
  CLICKED_MEETINGS_LINK: null,
  CLICKED_FOR_USER_DESCRIPTION: null,

  // WINDOW
  CHANGE_WINDOW_LOCATION: null,

  // CLIENT DATA
  CONVERSATIONS_CLIENT_READY: null,
  FORCE_CLIENT_OFFLINE: null,

  // SNIPPETS
  GET_SNIPPETS: null,
  GET_SNIPPETS_FAILED: null,
  GET_SNIPPETS_SUCCEEDED: null,

  // AGENTS
  GET_AGENT: null,
  GET_AGENT_FAILED: null,
  GET_AGENT_SUCCEEDED: null,

  // PRESENCE
  SEND_ONLINE_PRESENCE_NOTICE: null,
  SEND_OFFLINE_PRESENCE_NOTICE: null,
  SEND_PRESENCE_HEARTBEAT: null,

  START_CHANNEL_SUBSCRIBE_POLL: null,
  INCREMENT_CHANNEL_SUBSCRIBE_COUNT: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/constants/ActionTypes.js
// module id = 4
// module chunks = 0 1